const styles = `:host {
  display: inline-flex;
}

::slotted(chameleon-toolbar-button) {
  border-right: 1px solid var(--goto-border-color-default);
}

::slotted(chameleon-toolbar-button:first-child) {
  --goto-toolbar-button-left-radius: var(--goto-radius-small);
}

::slotted(chameleon-toolbar-button:last-child) {
  --goto-toolbar-button-right-radius: var(--goto-radius-small);
  border-right: none;
}`; export default styles;